import axios from "axios";
import {
  TWO_FACTOR_ATTEMPT,
  TWO_FACTOR_SUCCESS,
  TWO_FACTOR_FAILED,
  TWO_FACTOR_UPDATE_SUCCESS,
  TWO_FACTOR_UPDATE_FAILED,
  TWO_FACTOR_SETUP_SUCCESS,
  TWO_FACTOR_SEND_SUCCESS,
} from "../types/twoFactorTypes";
import { config } from "../../config";
import {
  getTwoFactorSettings,
  saveTwoFactorSettings,
} from "../../assets/lang/twoFactorUtils";

const url_api = config.api.godiway;
const axiosOptions = { validateStatus: (status) => status >= 200 && status < 600 };

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

export function loading() {
  return { type: TWO_FACTOR_ATTEMPT };
}

export function success(data) {
  return { type: TWO_FACTOR_SUCCESS, data };
}

export function failed(error) {
  return { type: TWO_FACTOR_FAILED, error };
}

export function successUpdate(data) {
  return { type: TWO_FACTOR_UPDATE_SUCCESS, data };
}

export function failedUpdate(error) {
  return { type: TWO_FACTOR_UPDATE_FAILED, error };
}

export function successSetup(data) {
  return { type: TWO_FACTOR_SETUP_SUCCESS, data };
}

export function successSend(data) {
  return { type: TWO_FACTOR_SEND_SUCCESS, data };
}

const handleResponse = (response, userId, dispatch, successAction) => {
  if (response.data.status === "Success") {
    const current = getTwoFactorSettings(userId);
    const merged = { ...current, ...response.data.body };
    saveTwoFactorSettings(userId, merged);
    dispatch(successAction(merged));
    return true;
  }
  return false;
};

export const loadTwoFactor = (data) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.get(`${url_api}auth/2fa`, {
      ...axiosOptions,
      params: { id: data.user_id },
      headers: authHeaders(data.token),
    });

    if (response.data.status === "Success") {
      saveTwoFactorSettings(data.user_id, response.data.body);
      dispatch(success(response.data.body));
      return;
    }
  } catch (error) {
    // fall back to local storage
  }

  dispatch(success(getTwoFactorSettings(data.user_id)));
};

export const updateTwoFactor = (data) => async (dispatch) => {
  const payload = {
    enabled: data.enabled ? "on" : "off",
    method: data.method,
    email: data.email || "",
    phone: data.phone || "",
    otpauthUrl: data.enabled ? data.otpauthUrl || "" : "",
  };

  saveTwoFactorSettings(data.user_id, {
    ...getTwoFactorSettings(data.user_id),
    ...payload,
    enabled: data.enabled,
  });

  try {
    const response = await axios.post(
      `${url_api}auth/2fa`,
      {
        id: data.user_id,
        enabled: data.enabled ? "on" : "off",
        method: data.method,
      },
      {
        ...axiosOptions,
        headers: authHeaders(data.token),
      }
    );

    if (handleResponse(response, data.user_id, dispatch, successUpdate)) {
      return;
    }

    dispatch(failedUpdate(response.data.body || "try_later"));
  } catch (error) {
    dispatch(failedUpdate("try_later"));
  }
};

export const sendTwoFactorCode = (data) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.post(
      `${url_api}auth/2fa/send`,
      {
        id: data.user_id,
        method: data.method,
      },
      {
        ...axiosOptions,
        headers: authHeaders(data.token),
      }
    );

    if (handleResponse(response, data.user_id, dispatch, successSend)) {
      return;
    }

    dispatch(failedUpdate(response.data.body || "try_later"));
  } catch (error) {
    dispatch(failedUpdate("try_later"));
  }
};

export const setupTwoFactorAuthenticator = (data) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.post(
      `${url_api}auth/2fa/setup`,
      { id: data.user_id },
      {
        ...axiosOptions,
        headers: authHeaders(data.token),
      }
    );

    if (handleResponse(response, data.user_id, dispatch, successSetup)) {
      return;
    }

    dispatch(failedUpdate(response.data.body || "try_later"));
  } catch (error) {
    dispatch(failedUpdate("try_later"));
  }
};

export const verifyTwoFactor = (data) => async (dispatch) => {
  dispatch(loading());

  try {
    const response = await axios.post(
      `${url_api}auth/2fa/verify`,
      {
        id: data.user_id,
        code: data.code,
      },
      {
        ...axiosOptions,
        headers: authHeaders(data.token),
      }
    );

    if (handleResponse(response, data.user_id, dispatch, successUpdate)) {
      return;
    }

    dispatch(failedUpdate(response.data.body || "user_wrong"));
  } catch (error) {
    dispatch(failedUpdate("try_later"));
  }
};
